import React from "react";

const Profile = (props) => {



    return <div className={props.active}>
        <div className="profile">
            <div className="rob-list__title  rob-list__title--modal"><h2>{props.profile['name']}</h2></div>
            <div className="rob-profile__row">
                <div className="rob-profile__image" style={{ backgroundImage: `url(${props.profile['image']})` }}>
                </div>
                <div className="rob-profile__content" dangerouslySetInnerHTML={{__html: props.profile['description']}}>
                </div>
            </div>
        </div>
    </div>
};

Profile.defaultProps = {profile: []};
export default Profile


// WEBPACK FOOTER //
// ./src/components/elements/modals/Profile.js